












import { Vue, Component, Prop, Watch, Emit, Ref } from "vue-property-decorator";
import { OrderDto } from "../../../types/impl/OrderDto";
import { IOrderDto } from "../../../types/interface/IOrderDto";
import { OrderStatus, DeliveryType } from "../../../types/enum/OrderEnum";

export interface IStepItem {
  text: string;
  icon: string;
  active: OrderStatus;
}

@Component
export default class Step extends Vue {
  @Prop({ default: () => ({ ...OrderDto }) }) order!: IOrderDto;
  @Prop({ default: () => [] }) items!: Array<IStepItem>;

  renderColor(active: OrderStatus) {
    if (
      this.order.deliveryType === DeliveryType.Delivery &&
      this.order.orderStatus === OrderStatus.Ready
    ) {
      return this.order.orderStatus > active ? this.$color : this.$default;
    }
    return this.order.orderStatus >= active ? this.$color : this.$default;
  }
}
